import { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks! Our team will reach out shortly.");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <div className="max-w-6xl mx-auto px-5 py-16 grid lg:grid-cols-2 gap-12">
      <div>
        <h1 className="font-head text-4xl font-extrabold tracking-tight text-[#0A1128]">Talk to GTForce</h1>
        <p className="mt-4 text-lg text-slate-600">Whether you want to deploy a workforce or join one, we'd love to hear from you.</p>
        <div className="mt-8 space-y-4 text-slate-700">
          <div className="flex items-center gap-3"><Mail className="text-[#1D4ED8]" size={18} /> hello@gtforce.world</div>
          <div className="flex items-center gap-3"><Phone className="text-[#1D4ED8]" size={18} /> +91 44 4000 0000</div>
          <div className="flex items-center gap-3"><MapPin className="text-[#1D4ED8]" size={18} /> Global HQ · Chennai, India</div>
        </div>
      </div>
      <form onSubmit={submit} className="p-8 rounded-2xl border border-slate-200 bg-white space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">Name</label>
          <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:border-[#1D4ED8] focus:ring-1 focus:ring-[#1D4ED8] outline-none" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Email</label>
          <input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:border-[#1D4ED8] focus:ring-1 focus:ring-[#1D4ED8] outline-none" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Message</label>
          <textarea data-testid="contact-message" required rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:border-[#1D4ED8] focus:ring-1 focus:ring-[#1D4ED8] outline-none" />
        </div>
        <button data-testid="contact-submit" className="w-full py-3 rounded-full bg-[#1D4ED8] text-white font-semibold hover:bg-[#1E40AF] transition-colors">Send Message</button>
      </form>
    </div>
  );
}
